import React, { useState } from "react";
import "../../components/StelmartAdvantage/StelmartAdvantage.css";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IoClose, IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { FaHeadphonesAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const StelmartAdvantage = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const navigate = useNavigate();

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };


  const handleHelpSupportClick = () => {
    navigate('/contact-us');
    setIsPopupOpen(false);
  };


  return (
    <>
      <div className="">
        <h2 className="advantage font-merriweather">
          The <span className="highlight">Stelmart</span> Advantage
        </h2>
        <p className="description-advantage custom-inner-space font-poppins">
          What sets Stelmart apart from others in the industry is our relentless focus on solving the core challenges businesses face.
          With Stelmart, you don't just get a marketplace; you get a partner committed to driving your success.
        </p>
        <div className="grid-container-advantage custom-inner-space font-merriweather">
          <div className="column-advantage">
            <h3 className="adv-heading">Challenge</h3>
            <p className="adv-para">Market Fragmentation</p>
            <p className="adv-para">Payment Risks</p>
            <p className="adv-para">Limited Financing</p>
            <p className="adv-para">Supply Chain Disruptions</p>
            <p className="adv-para">Lack of Market Insights</p>
            <p className="adv-para">Trust Deficit</p>
          </div>
          <div className="vertical-line"></div>
          <div className="column-advantage">
            <h3 className="adv-heading">Traditional Market</h3>
            <p className="adv-para">Multiple Intermediaries, High Costs</p>
            <p className="adv-para">Uncertain Payments, Defaults</p>
            <p className="adv-para">Cash Flow Constraints</p>
            <p className="adv-para">Production Delays Due To Fund Shortages</p>
            <p className="adv-para">Pricing Opacity, Demand Unpredictability</p>
            <p className="adv-para">Quality Inconsistencies, Unreliable Suppliers</p>
          </div>
          <div className="vertical-line"></div>
          <div className="column-advantage">
            <h3 className="adv-heading">Stelmart Solution</h3>
            <p className="adv-para">Direct Buyer-Seller Connections</p>
            <p className="adv-para">Escrow-Backed Payments For Security</p>
            <p className="adv-para">NBFC-Backed Credit Facilities</p>
            <p className="adv-para">Advance Payments For Stability</p>
            <p className="adv-para">Real-Time Analytics And Forecasting</p>
            <p className="adv-para">Verified Participants And Digital Tracking</p>
          </div>
        </div>
      </div>

      <div className="background-container-platform">
        <div className="overlay-platform custom-inner-space">
          <div className="grid-layout">
            <div className="content-sections">
              <h2 className="advantage-platform font-merriweather">
                A Unified Platform for Buyers, Sellers, and Financial Institutions
              </h2>
              <p className="description-advantage-platform font-poppins">
                <strong className="extended-line-description">— The Need of the Hour</strong>
              </p>
              <p className="description-advantage-platform font-poppins">
                The steel and polymer industries have long needed a digital platform that integrates buyers, sellers, and financial institutions in a way that fosters trust, reduces inefficiencies, and creates new opportunities for growth.
              </p>
              <p className="description-advantage-platform font-poppins">
                Stelmart is that platform. By uniting all stakeholders in one ecosystem, Stelmart ensures that everyone—from manufacturers to financial institutions—can engage in seamless transactions with confidence.
              </p>
            </div>

            <div className="svg-section" onClick={togglePopup}>
              <motion.div
                className="circular-text"
                animate={{ rotate: 360 }}
                transition={{ duration: 5, repeat: Infinity, ease: "linear" }}
              >
                <svg viewBox="0 0 100 100">
                  <path
                    id="circlePath"
                    d="M 50,50 m -40,0 a 40,40 0 1,1 80,0 a 40,40 0 1,1 -80,0"
                  />
                  <text>
                    <textPath href="#circlePath" startOffset="0">
                      Get In Touch Get In Touch Get In Touch &nbsp;&nbsp;&nbsp;&nbsp;
                    </textPath>
                  </text>
                </svg>
              </motion.div>
              <div className="center-icon">
                <ArrowUpRight size={24} strokeWidth={2} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {isPopupOpen && (
        <div className="popup">
          <div className="popup-content">
            <IoClose className="close-popup-icon" onClick={togglePopup} />
            <h2 className="popup-title font-merriweather">
              <FaHeadphonesAlt /> Connect with us
            </h2>
            <div className="contact-card">
              <div className="contact-item">
                <div className="contact-icon-circle">
                  <IoCall className="contact-icon" />
                </div>
                <div className="contact-details font-lato">
                  <p className="contact-title">Call us</p>
                  <p className="contact-info">
                    <a href="tel:+917011588280">+91 7011588280</a>
                  </p>
                  <p className="contact-subinfo">Mon-Fri | 10am to 7pm</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon-circle">
                  <MdEmail className="contact-icon" />
                </div>
                <div className="contact-details font-lato">
                  <p className="contact-title">Write to us</p>
                  <p className="contact-info">
                    <a href="mailto:info@stelmart.co.in">info@stelmart.co.in</a>
                  </p>
                </div>
              </div>
              <button className="help-support-button" onClick={handleHelpSupportClick}>
                Help & Support
              </button>            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StelmartAdvantage;
